import { useHistory, useLocation, useParams } from 'react-router-dom'
import { DefaultPage } from '@shared/layout/DefaultPage'
import { ROUTES } from '@shared/constants/routes'
import {
	TrainingDetailsSurface,
	type TrainingDetailsMuscleItem,
} from '@widgets/trainingDetailsOverlay'
import {
	FILTER_MUSCLE_SECTIONS,
} from '@pages/TrainingConstructor/ui/filter/filterCatalog'
import { FilterMuscleCard } from '@pages/TrainingConstructor/ui/filter/muscleCard'
import '@pages/TrainingConstructor/ui/training-constructor.css'

const SILENT_TRAINING_DETAILS_CLOSE_CLASS = 'training-details-route-silent-close'
const TRAINING_DETAILS_MUSCLE_ITEMS: TrainingDetailsMuscleItem[] =
	FILTER_MUSCLE_SECTIONS.flatMap((section) => section.items)
type TrainingDetailsLocationState = {
	trainingDetailsReturnTo?: string
}

const renderTrainingDetailsMuscleCard = (muscle: TrainingDetailsMuscleItem) => (
	<FilterMuscleCard muscle={muscle} isSelected isReadonly />
)

export const TrainingDetailsPage = () => {
	const { trainingID } = useParams<{ trainingID: string }>()
	const history = useHistory()
	const location = useLocation<TrainingDetailsLocationState | undefined>()
	const workoutId = Number(trainingID)
	const isValidWorkoutId = Number.isFinite(workoutId) && workoutId > 0

	const finishRouteClose = () => {
		document.body.classList.add(SILENT_TRAINING_DETAILS_CLOSE_CLASS)
		history.replace(
			location.state?.trainingDetailsReturnTo ??
				`${ROUTES.overall.trainingConstructor}?tab=my_trainings`,
		)
	}

	return (
		<DefaultPage noPadding className="training-details-route-page">
			<TrainingDetailsSurface
				workoutId={workoutId}
				isValidWorkoutId={isValidWorkoutId}
				muscleItems={TRAINING_DETAILS_MUSCLE_ITEMS}
				onDismiss={finishRouteClose}
				renderMuscleCard={renderTrainingDetailsMuscleCard}
			/>
		</DefaultPage>
	)
}
